"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdkData = exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
exports.props = withCompInfo_1.withCompInfo(['skin', 'compProps', 'isMobileView'], function (_a, carmiData) {
    var skin = _a.skin, compProps = _a.compProps, isMobileView = _a.isMobileView;
    var galleryImageOnClickAction = compProps.galleryImageOnClickAction, goToLinkText = compProps.goToLinkText, aspectRatio = compProps.aspectRatio, imageMode = compProps.imageMode, loop = compProps.loop;
    return {
        skin: skin,
        goToLinkText: goToLinkText || 'Go to link',
        aspectRatio: aspectRatio,
        keepImageAspectRatio: imageMode === 'flexibleWidth',
        items: carmiData.itemsProps,
        imageOnClickAction: galleryImageOnClickAction,
        playOnHover: !isMobileView,
        playInLoop: loop,
    };
});
exports.css = withCompInfo_1.withCompInfo(['compProps'], function (_a) {
    var compProps = _a.compProps;
    var margin = compProps.margin;
    return {
        '--spacing': margin + "px",
    };
});
exports.sdkData = withCompInfo_1.withCompInfo(['compData'], function (_a) {
    var compData = _a.compData;
    return {
        imageDisplayMode: 'fill',
        dataId: compData.id,
    };
});
//# sourceMappingURL=SliderGallery.js.map